import { render, staticRenderFns } from "./EarnBadge.vue?vue&type=template&id=6822c9aa"
import script from "./EarnBadge.vue?vue&type=script&lang=js"
export * from "./EarnBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports